import React from 'react';
interface MarqueeStripeProps {
  phrases?: string[];
  bgColor?: string;
  textColor?: string;
}
export function MarqueeStripe({
  phrases = ['Stack it up', 'Butter be wearing it', 'Layer your way', 'Stacked in Butter', 'Mix. Match. Stack.'],
  bgColor = '#F5D76E',
  textColor = '#6B1D4A'
}: MarqueeStripeProps) {
  // Duplicate phrases to ensure smooth infinite scrolling
  const allPhrases = [...phrases, ...phrases, ...phrases, ...phrases];
  return <div className="w-full overflow-hidden py-3 border-y border-opacity-20 border-[#6B1D4A]" style={{
    backgroundColor: bgColor
  }} data-id="element-188">
      <div className="flex whitespace-nowrap animate-marquee w-[200%]" data-id="element-189">
        {allPhrases.map((phrase, index) => <div key={index} className="flex items-center mx-4" style={{
        color: textColor
      }} data-id="element-190">
            <span className={`text-lg md:text-xl ${index % 2 === 0 ? 'font-heading font-bold' : 'font-body uppercase tracking-wider'}`} data-id="element-191">
              {phrase}
            </span>
            <span className="mx-8 text-sm opacity-50" data-id="element-192">✦</span>
          </div>)}
      </div>
    </div>;
}